import { Pipe, PipeTransform } from '@angular/core';
import { orderGuestLabel } from '@app/helpers/reciprocal.helper';

@Pipe({
  name: 'orderGuestLabel',
  // Guest overlay edits order.data.guest on the same order instance.
  pure: false,
})
export class OrderGuestLabelPipe implements PipeTransform {
  transform(order: any): string {
    return orderGuestLabel(order);
  }
}
